import { memo } from 'react';

/**
 * TypingIndicator - Shows who is typing
 * Apple iMessage-inspired design with light/dark mode support
 */

function TypingIndicator({ typingUsers = [] }) {
  if (typingUsers.length === 0) return null;

  const getTypingText = () => {
    if (typingUsers.length === 1) {
      return `${typingUsers[0].userName} is typing`;
    }
    if (typingUsers.length === 2) {
      return `${typingUsers[0].userName} and ${typingUsers[1].userName} are typing`;
    }
    return `${typingUsers[0].userName} and ${typingUsers.length - 1} others are typing`;
  };

  return (
    <div className="px-4 py-2 flex items-center gap-2">
      {/* Animated dots */}
      <div className="flex gap-1">
        <span className="w-1.5 h-1.5 bg-[#86868b] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-1.5 h-1.5 bg-[#86868b] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-1.5 h-1.5 bg-[#86868b] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
      <span className="text-[#86868b] text-xs">{getTypingText()}</span>
    </div>
  );
}

export default memo(TypingIndicator);
